import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { downloadMDoc } from "../../components/microsoft-entraid-integration/helper-ms";

const SSODownloadRedirect = () => {
    const navigate = useNavigate();
    const hasDownloaded = useRef(false); // prevents double execution

    useEffect(() => {
        if (!hasDownloaded.current) {
            hasDownloaded.current = true; //  flag download only once
            downloadMDoc();

            setTimeout(() => {
                navigate("/msentraidlanding"); // redirect after download
            }, 1000);
        }
    }, [navigate]);

    return <div>Preparing download...</div>;
};

export default SSODownloadRedirect;
